import React from 'react';
import { SvgCircleIcon, IconComponent, IconGlyphComponent } from '@shapeable/icons';

export const TransportIcon: IconComponent = (props) => (
  <SvgCircleIcon { ...props } glyphWidth={96} glyphHeight={96}>

  </SvgCircleIcon>
);

export const TransportIconGlyph: IconGlyphComponent = (props) => <TransportIcon { ...props } variant='glyph' />;